import api from '../../../../App/socket';

export const getUserProfileGroupsList = params => (
    api.send({
        api: 'db',
        model: 'User_group',
        action: 'Read',
        options: {
            where: { _id: params._id },
            attributes: ['name', 'description'],
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_profile_groups_requests/get_groups_list.js